module.exports = __webpack_public_path__ + "img/1.753318d9.jpg";